<script lang="ts">
  // Renders a card-sleeve (card back) for the customizer catalog, pixel-identical to the duel board.
  // Image sleeves (the classic card back) show the real art; procedural sleeves are drawn on a canvas
  // via the shared draw routine.
  import { drawSleeve, sleeveById } from "../../duel/sleeves.ts";

  let { id, res = 200 }: { id: string; res?: number } = $props();
  let canvas: HTMLCanvasElement;
  const def = $derived(sleeveById(id));

  $effect(() => {
    if (!canvas || def.kind === "image") return;
    const h = Math.round((res * 86) / 59);
    canvas.width = res; canvas.height = h;
    drawSleeve(canvas.getContext("2d")!, id, res, h);
  });
</script>

{#if def.kind === "image" && def.img}
  <img src={def.img} alt={def.name} class="block size-full object-cover" draggable="false" />
{:else}
  <canvas bind:this={canvas} class="block size-full" style="image-rendering:auto"></canvas>
{/if}
